import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PhoneMissedIcon(props: IconProps) {
    return <Icon {...props} iconKey={"phone_missed"}/>
}
